import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ThirdPartyService } from '../services/third-party.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from '../services/utils.service';
import { StatsigClient, StatsigOptions, StatsigUser } from '@statsig/js-client';
declare var window: any;

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css']
})
export class PublicComponent implements OnInit, AfterViewInit {
  //Variáveis
  @ViewChild('modalApp') modalApp!: ElementRef;

  isNavCollapsed = true; //Flag Indicando Navbar Collapsada em Celulares

  pathImageProvider = 'https://estudei-frontend-web.s3.us-east-2.amazonaws.com/assets/'; //Endereço Base da URL Para Exibição das Imagens
  pathImageProviderLocal = '/assets/public/'; //Endereço Base da URL Para Exibição das Imagens

  pageVersion: '' | '_enem' | '_rm' = ''; //Versão a Exibir da LP

  checks = [ //Itens dos Checks
    'Cria seu planejamento de forma automática',
    'Controla suas revisões',
    'Monitora suas metas e constâncias de estudo',
    'Controla seu desempenho por assunto no edital verticalizado',
    'Marca suas horas liquidas de estudo com cronômetro interativo',
    'Controla seus simulados e provas',
    'Gera relatórios de desempenho e estatísticas',
    'A única coisa que não faz, é estudar por você'
  ];

  checkStats: Array<{ //Estatísticas dos Checks
    icon: string,
    value: number,
    unit?: string,
    description: string
  }> = [];

  feedbacks1 = [ //Feedbacks em Mídia
    {
      statement: [
        'Achei a plataforma imersiva, super fácil e intuitiva para usar, além de ter um visual clean que não interfere em nada nos seus estudos, pois não te cansa!',
        'Acho que qualquer concurseiro(a) irá curtir, porque não tem nada assim no mercado, principalmente, porque você pode montar seu ciclo de estudos ou usar um sugerido pela plataforma, contar suas horas e ainda você pode individualizar pela sua área de foco.',
        'Indico demais!'
      ],
      author: 'Viviane Carneiro',
      media: 'd_viviane_carneiro.jpg'
    },
    {
      statement: [
        'A plataforma é sensacional! Ela tem me ajudado muito no planejamento e na organização dos meus estudos. As funcionalidades são excepcionais, principalmente o plano de estudos, que leva em conta o quanto que eu já sei de cada matéria para alocar o tempo para as tarefas. Ficou muito mais fácil cumprir as minhas metas com o Estudei!'
      ],
      author: 'Michelle Tonelli',
      media: 'd_michelle_tonelli.png'
    },
    {
      statement: [
        'A plataforma Estudei vem me ajudando muito nos estudos tanto para os concursos quanto para a faculdade. Com ela consigo manter todos os meus controles em um só lugar. Também consigo controlar melhor meus pontos fracos, saber onde estou errando mais e puder desenvolver melhor esses pontos. Já super recomendo a plataforma!!!',
        'É plenamente adaptada pra quem estuda pra concursos públicos. Consigo controlar o que fiz, onde parei, seja em páginas, seja anotando algo que preciso destacar. Além disso, se esqueci do que fiz numa sessão de uma disciplina, facilmente tenho tudo muito rápido e prático no histórico. Não preciso mais perder tempo procurando nada.',
        'De fato, estou sem palavras!!! É a melhor plataforma pra quem quer estudar e se manter firme nos estudos.'
      ],
      author: 'Fabiana',
      media: 'd_fabiana.jpg'
    },
    {
      statement: [
        'A plataforma possui um layout agradável que conta também com o visual noturno que ajuda a evitar o cansaço dos olhos.',
        'O controle por registro de hora estudada é estimulante, pois pequenos avanços diários no longo prazo traz grande satisfação com o sentimento de dever realizado. Observar cada avanço é muito gratificante, pois mostra que o compromisso é sério e que o esforço vale a pena.',
        'Recomendo bastante o uso da plataforma. É a primeira vez que adoto um sistema de controle de estudo e posso falar por experiência própria que o estudo diário se transforma para melhor totalmente quando se tem um método de controle e registro. A eficiência e produtividade aumentam bastante!'
      ],
      author: 'Guilherme Souza',
      media: 'd_guilherme_souza.jpg'
    }
  ];
  selectedFeedback1 = 0; //Feedback a ser Visualizado

  steps = [
    {
      id: 1,
      title: 'Escolher seu Edital',
      description: [
        'Você <span>cria seu plano</span> selecionando para qual prova ou concurso você quer estudar. São centenas de editais já cadastrados em nosso sistema.',
        'Você também poderá criar um <span>plano personalizado</span> e adicionar as disciplinas e assuntos que quiser.'
      ],
      image: 'e_step_01.png'
    },
    {
      id: 2,
      title: 'Criar seu Planejamento Inteligente',
      description: [
        'Você entra com as <span>informações sobre sua rotina</span> (carga horária, sessões...) e sua <span>relação com as matérias</span> (facilidades e dificuldades, conhecimentos prévios...) e o Estudei monta seu planejamento para você.',
      ],
      image: 'e_step_02.png'
    },
    {
      id: 3,
      title: 'Registrar seus estudos diários',
      description: [
        'Aqui, você vai <span>registrar sua sessão de estudos</span>: duração, a categora (teoria, questões, revisão...), a disciplina e o tópico estudados. Simples e rápido.'
      ],
      image: 'e_step_03.png'
    },
    {
      id: 4,
      title: 'Agora é só conferir seus resultados e acompanhar sua evolução',
      description: [
        'Avanço no edital, desempenho por matérias e tópicos, metas, constância nos estudos, controle de revisões, distribuição do tempo... No estudei, você vai <span>acompanhar todas as estatísticas</span> pertinentes e conseguir <span>direcionar seus estudos</span>.'
      ],
      image: 'e_step_04.png'
    }
  ];

  spoilers = [ //Detalhes no Print da Tela Home
    'Visão geral do seu avanço por matéria: tempo e desempenho nas questões',
    'Acompanhe suas metas semanais de horas e questões!',
    'Confira aqui as próximas tarefas do dia e as revisões programadas',
    'Veja aqui como está o seu avanço no dia: tempo total e distribuição entre as matérias',
    'Chega de se esquecer de pagar os boletos, fazer inscrições, baixar aulas... Organize seus lembretes em um só lugar!',
    'Acompanhe todos os seus últimos registros aqui!'
  ];

  subscriptions = [ //Assinaturas
    // {
    //   period: 'Mensal',
    //   oldPrice: 0,
    //   price: 16.90,
    //   quota: 0,
    //   cashPrice: 0,
    //   saving: 0,
    //   observation: 'por mês',
    //   link: ''
    // },
    {
      period: 'Anual',
      oldPrice: 197.90,
      price: 19.75,
      quota: 12,
      cashPrice: 197.90,
      saving: 50,
      observation: '',
      link: 'https://pay.hotmart.com/O89145386V?off=da5txb2g&checkoutMode=10&',
      activeCampaignFormId: 19,
      activeCampaignFormOr: 'cc6c010fc7269af0437d38d75905d6c6'
    },
    // {
    //   period: 'Semestral',
    //   oldPrice: 89.40,
    //   price: 12.90,
    //   quota: 6,
    //   cashPrice: 75.00,
    //   saving: 19,
    //   observation: '',
    //   link: ''
    // }
  ];
  preSubscription = {
    name: '',
    email: '',
    phone: ''
  }

  isPDA = false; //Flag Indicando que Veio Pelo Link da Planilha

  feedbacks2 = [ //Feedbacks em Prints
    {
      statement: 'h_amanda_vieira.png',
      author: 'Amanda Vieira',
      media: 'h_amanda_vieira_photo.jpg'
    },
    {
      statement: 'h_clara_lopes.png',
      author: 'Clara Lopes',
      media: 'h_clara_lopes_photo.jpg'
    },
    {
      statement: 'h_cristiano.png',
      author: 'Cristiano',
      media: 'h_cristiano_photo.jpg'
    },
    {
      statement: 'h_dalila_fernandes.png',
      author: 'Dalila Fernandes',
      media: 'h_dalila_fernandes_photo.jpg'
    },
    {
      statement: 'h_fabricio_oliveira.png',
      author: 'Fabricio Oliveira',
      media: 'h_fabricio_oliveira_photo.jpg'
    },
    {
      statement: 'h_lucas_silva.png',
      author: 'Lucas Silva',
      media: 'h_lucas_silva_photo.jpg'
    }
  ];

  aboutUs = [ //Quem Somos Nós
    {
      name: 'Renan Cristofori',
      about: 'Criador da Planilha do Aprovado com mais de 35.000 alunos, foi aprovado no ISS Guarulhos e é especialista em planejamento e organização de estudos.',
      image: 'i_renan.png'
    },
    {
      name: 'Laura Amorim',
      about: 'Criadora dos Mapas da Lulu com mais de 40.000 alunos, foi aprovada no Sefaz SC, Sefaz GO, Polícia Federal e Câmara de BH. É pós-graduada em neuroeducação e é especialista em preparação para provas e concuros.',
      image: 'i_laura.png'
    },
    {
      name: 'Gustavo Salzmann',
      about: 'Engenheiro de computação com ênfase no desenvolvimento de software, especializado em front-end e na criação de interfaces modernas. É entusiasta das últimas tendências e avanços em tecnologia.',
      image: 'i_gustavo.png'
    },
    {
      name: 'Andrei Bastos',
      about: 'Engenheiro eletricista com ênfase em computação e telecomunicações. Atua no mercado há mais de 9 anos e é responsável pelo back-end do Estudei.',
      image: 'i_andrei.png'
    }
  ];
  selectedPerson = 0; //Pessoa Selecionada a Exibir em 'Quem Somos Nós'

  faq = [ //Dúvidas Frequentes
    {
      question: 'O que é o Estudei?',
      answer: `
        <strong>O Estudei é uma plataforma de acompanhamento e controle de estudos como você nunca viu antes.</strong> Além daquilo que você espera de uma ferramenta assim – tudo reformulado e melhorado, é claro – temos funcionalidades inteligentes e exclusivas que vão direcionar e otimizar os seus estudos.
        <br /><br /><strong>Aqui estão algumas das funcionalidades do Estudei:</strong>
        <ul>
          <li>Montar seu ciclo de estudos personalizado automaticamente</li>
          <li>Controlar e acompanhar suas revisões</li>
          <li>Monitorar seus estudos</li>
          <li>Acompanhar seu edital verticalizado</li>
        </ul>
      `
    },
    {
      question: 'Como eu acesso a plataforma?',
      answer: 'Assim que você completar o pagamento, <strong>receberá um e-mail do Estudei com um link personalizado</strong> para acessar a plataforma pela primeira vez e configurar sua senha. Para os próximos acessos, basta ir em <a href="https://www.estudei.com.br" target="_blank">estudei.com.br</a>.'
    },
    {
      question: 'Não recebi o e-mail com o link de acesso, o que posso fazer?',
      answer: 'Se não tiver recebido o e-mail com os dados (verifique a caixa de spam!), <strong>é só enviar um e-mail para a gente em <a href="mailto:contato@estudei.com.br">contato@estudei.com.br</a></strong> que te enviaremos em resposta seu link personalizado de configuração do acesso.'
    },
    {
      question: 'Como entro em contato com o suporte?',
      // answer: 'Você pode falar com a gente por e-mail no <a href="mailto:contato@estudei.com.br">contato@estudei.com.br</a> ou por WhatsApp através do número <a href="https://wa.me/5527996936277" target="_blank">(27) 99693-6277</a>. Estamos à disposição!'
      answer: 'Você pode falar com a gente por e-mail no <a href="mailto:contato@estudei.com.br">contato@estudei.com.br</a>. Estamos à disposição!'
    },
    {
      question: 'Onde encontro tutoriais da plataforma?',
      answer: 'Você encontra nossos tutoriais em vídeo no nosso canal <a href="https://www.youtube.com/@estudei.oficial" target="_blank">https://www.youtube.com/@estudei.oficial</a>.'
    },
    {
      question: 'Esta é uma plataforma para alunos iniciantes ou avançados?',
      answer: '<strong>O Estudei te ajudará em qualquer fase dos estudos</strong> em que você se encontre! Seja iniciante, intermediário ou avançado, todos os alunos terão grandes ganhos ao registrar seus estudos e acompanhar suas metas e métricas. Se você está começando agora, comece registrando seus estudos diários. Se já está nesta jornada há mais tempo e quiser, pode registrar de forma retroativa os registros que já tem, ou mesmo começar a fazê-los a partir de agora.'
    },
    {
      question: 'É para concurseiros ou estudantes de qual área?',
      answer: 'O Estudei pode ser usado por qualquer estudante. <strong>Ele é 100% personalizável</strong>. Você pode tanto usar editais e assuntos já registrados como criar planos de estudos completamente novos e de acordo com as suas necessidades.'
    },
    {
      question: 'Qual o tempo de acesso à plataforma?',
      answer: 'Enquanto sua assinatura estiver vigente, você pode acessar e usufruir da plataforma.'
    },
    {
      question: 'Quais as formas de pagamento?',
      answer: 'Você pode assinar utilizando o cartão de crédito de forma à vista ou parcelada, ou então o PIX à vista.'
    },
    {
      question: 'Qual a diferença entre o Estudei e a Planilha do Aprovado?',
      answer: `
        O Estudei é uma plataforma de controle de estudos muito mais poderosa que a planilha.
        <br /><strong>Algumas diferenças bem diretas:</strong>
        <ul>
          <li>Você pode acessar o Estudei de qualquer computador, tablet ou smartphone (enquanto a planilha é um arquivo que só funciona bem em computadores windows e não pode ser aberta em outros dispositivos).</li>
          <li>A interface do Estudei é muito mais intuitiva e completa (bem mais bonita e agradével também)</li>
          <li>O Estudei tem gráficos e estatísticas bem mais fáceis de visualizar e navegar</li>
          <li>Como uma plataforma no modelo assinatura, o Estudei estará em constante evolução! Logo teremos novas funcionalidades e melhorias!</li>
        </ul>
      `
    },
    {
      question: 'É possível importar minha Planilha do Aprovado para não perder meus dados?',
      answer: 'Claro! Pensando em como melhor atender os usuários da planilha, implementamos uma funcionalidade para importação completa dos dados nela já registrados! Basta você fazer o upload do arquivo, que o resto é por nossa conta.'
    },
    {
      question: 'É possível utilizar o Estudei no modo off-line?',
      answer: 'O Estudei é uma plataforma em nuvem, <strong>só podendo ser acessada quando o computador, celular ou tablet estiver conectado à internet</strong>. Caso você estude off-line, pode deixar para fazer os registros no final do dia de forma manual.'
    },
    {
      question: 'Posso compartilhar meu acesso com outras pessoas?',
      answer: 'Não. Sua assinatura do Estudei é <strong>individual</strong> e <strong>intransferível</strong>.'
    },
    {
      question: 'Tive um problema com o pagamento e não consegui comprar, o que fazer?',
      answer: 'Basta mandar um e-mail pra gente em <a href="mailto:contato@estudei.com.br">contato@estudei.com.br</a> que trataremos da sua dificuldade individualmente.'
    }
  ];

  withLove = 'no ES'; //Local no Rodapé
  currentYear = new Date(); //Ano Atual Para Exibir no Rodapé

  constructor(
    public modalService: NgbModal,
    private _utilsService: UtilsService,
    private _thirdPartyService: ThirdPartyService,
    private _router: Router,
    private _aRoute: ActivatedRoute,
    private _title: Title
  ) { }

  ngOnInit(): void {
    this._title.setTitle('Estudei');

    //Versão a Exibir da LP
    if (this._router.url.includes('enem')) this.pageVersion = '_enem';
    else if (this._router.url.includes('residencia-medica')) this.pageVersion = '_rm';
    else this.pageVersion = '';

    this.steps.slice(0, 3).forEach(s => { s.image = s.image.replace('.png', `${this.pageVersion}.png`); });

    if (this.pageVersion == '_enem') {
      this.steps[0].description = [
        'Todas as <span>disciplinas</span> e os <span>tópicos</span> do ENEM e principais vestibulares prontinhos para você usar.',
        'Se preferir, poderá criar um <span>plano personalizado</span> e adicionar as disciplinas e assuntos que quiser.'
      ];

      this.subscriptions[0].activeCampaignFormId = 21;
      this.subscriptions[0].activeCampaignFormOr = '232bb7b42e4fbabe2ce86b3bd43f5ec4';
    }

    if (this.pageVersion == '_rm') {
      this.steps[0].description = [
        'Mais de <span>30 disciplinas</span> e <span>900 tópicos</span> já estão pré-cadastrados e prontinhos para você usar.',
        'Se preferir, poderá criar um <span>plano personalizado</span> e adicionar as disciplinas e assuntos que quiser.'
      ];

      this.subscriptions[0].activeCampaignFormId = 23;
      this.subscriptions[0].activeCampaignFormOr = '97f0f7ab29d1f035666135d209f2b5c3';
    }

    //Teste AB de Preço
    // this.TestAB();

    //Alterar Local de Criação no Rodapé
    setInterval(() => {
      this.withLove = (this.withLove == 'no ES' ? 'em MG' : 'no ES');
    }, 3000);

    // if (window.location.hash.includes('#/planilha')) {
    //   this.isPDA = true;
    //   this.subscriptions[0].price = 10.97;
    //   this.subscriptions[0].cashPrice = 109.90;
    //   this.subscriptions[0].link = 'https://estudei.com.br/planilha';
    // }

    //Obter Estatísticas Públicas
    this.GetPublicStatistics();
  }

  ngAfterViewInit(): void {
    //Pop-up App
    // this.modalService.open(this.modalApp, { centered: true, keyboard: false, size: 'lg' });
  }

  //Alterar o Depoimento a Ser Exibido em 'Feedbacks 1'
  ChangeFeedback(action: '+' | '-') {
    switch (action) {
      case '+':
        this.selectedFeedback1 = (this.selectedFeedback1 == (this.feedbacks1.length - 1) ? 0 : (this.selectedFeedback1 + 1));
        break;

      case '-':
        this.selectedFeedback1 = (this.selectedFeedback1 == 0 ? (this.feedbacks1.length - 1) : (this.selectedFeedback1 - 1));
        break;
    }
  }

  //Abrir Modal do Vídeo
  OpenVideo(div: any) {
    this.modalService.open(div, { centered: true, keyboard: false, size: 'xl' });
  }

  //Ir Para a Rede Social
  OpenSocial(social: string) {
    let url = '';
    if (social == 'i') url = 'https://instagram.com/estudei.oficial';
    if (social == 'f') url = 'https://facebook.com/estudei.oficial';
    if (social == 'y') url = 'https://youtube.com/@estudei.oficial';
    if (social == 'w') url = 'https://wa.me/5527997710427';

    window.open(url, '_blank');
  }

  //Ir Para a Página
  GoTo(page: string) {
    this._router.navigate(['/u' + page], { relativeTo: this._aRoute });
  }

  //Abrir Documentos
  GoDocuments(document: string) {
    const link = this._router.serializeUrl(this._router.createUrlTree([document], { relativeTo: this._aRoute }));
    window.open(link, '_blank');
  }

  //Assinar Hotmart
  GoCheckout(link: string) {
    window.open(link, '_self');
  }

  //Abrir Modal do AC
  OpenAC(div: any) {
    this.modalService.open(div, { centered: true, keyboard: false, size: 'sm' });
  }

  //Enviar Dados da Pré Inscrição
  Subscribe() {
    try {
      //Criar URL da ActiveCampaign
      let activeCampaign = `https://estudei01.activehosted.com/proc.php?u=${this.subscriptions[0].activeCampaignFormId}&f=${this.subscriptions[0].activeCampaignFormId}&s=&c=0&m=0&act=sub&v=2&or=${this.subscriptions[0].activeCampaignFormOr}&`
      activeCampaign += `fullname=${this.preSubscription.name.replace(/ /g, '+')}&`;
      activeCampaign += `email=${this.preSubscription.email}&`;
      activeCampaign += `phone=${this.preSubscription.phone}&`;
      activeCampaign += `jsonp=true`;
      //Requisitar ActiveCapaign
      this._thirdPartyService.createActiveCampaign(activeCampaign).subscribe(next => { });
    } catch (error) { }

    try {
      //Criar URL da Hotmart
      let hotmart = this.subscriptions[0].link;
      hotmart += `name=${this.preSubscription.name.replace(/ /g, '+')}&`;
      hotmart += `email=${this.preSubscription.email}&`;
      hotmart += `phoneac=${this.preSubscription.phone.toString().slice(0, 2)}&`;
      hotmart += `phonenumber=${this.preSubscription.phone.toString().slice(2)}`;
      //Redirecionar Para Hotmart
      window.clarity('event', 'PreCheckout');
      window.location.replace(hotmart);
    } catch (error) {
      window.location.replace(this.subscriptions[0].link);
    }
  }

  //Enviar Dados da Pré Inscrição
  SubscribeApp(divModal: any) {
    //Parâmetros de Publicidade
    const utmSource = this._aRoute.snapshot.queryParamMap.get('utm_source');
    const utmCampaign = this._aRoute.snapshot.queryParamMap.get('utm_campaign');
    const utmMedium = this._aRoute.snapshot.queryParamMap.get('utm_medium');
    const utmTerm = this._aRoute.snapshot.queryParamMap.get('utm_term');
    const utmContent = this._aRoute.snapshot.queryParamMap.get('utm_content');

    try {
      //Criar URL da ActiveCampaign
      let activeCampaign = 'https://estudei01.activehosted.com/proc.php?u=25&f=25&s=&c=0&m=0&act=sub&v=2&or=34bd6c47ee049077f1e66014af26e2c6&'
      activeCampaign += `fullname=${this.preSubscription.name.replace(/ /g, '+')}&`;
      activeCampaign += `email=${this.preSubscription.email}&`;
      activeCampaign += `phone=${this.preSubscription.phone}&`;
      activeCampaign += `jsonp=true&`;
      //Parâmetros de Publicidade
      if (utmSource) activeCampaign += `field[11]=${utmSource}&`;
      if (utmCampaign) activeCampaign += `field[12]=${utmCampaign}&`;
      if (utmMedium) activeCampaign += `field[13]=${utmMedium}&`;
      if (utmTerm) activeCampaign += `field[17]=${utmTerm}&`;
      if (utmContent) activeCampaign += `field[14]=${utmContent}&`;
      //Requisitar ActiveCapaign
      this._thirdPartyService.createActiveCampaign(activeCampaign).subscribe(next => { });
    } catch (error) { }

    //Fechar Modal
    divModal?.close();
  }

  //Navegar Até a Seção da Página
  GoSection(div?: any) {
    const y = div ? (div.getBoundingClientRect().top + window.scrollY - 100) : 0;
    window.scrollTo({ top: y, behavior: 'smooth' });
    this.isNavCollapsed = true;
  }

  //Obter Estatísticas Públicas
  GetPublicStatistics() {
    this._utilsService.getPublicStatistics().subscribe(
      stats => {
        //Adicionar Estatísticas Públicas aos Cards
        this.checkStats.push({
          icon: 'far fa-folder-open',
          value: stats.plans,
          description: 'Planos'
        });

        this.checkStats.push({
          icon: 'fas fa-layer-group',
          value: stats.subjects,
          description: 'Disciplinas'
        });

        this.checkStats.push({
          icon: 'fas fa-book-bookmark',
          value: stats.topics,
          description: 'Tópicos'
        });

        this.checkStats.push({
          icon: 'fas fa-calendar-alt',
          value: stats.plannings,
          description: 'Planejamentos'
        });

        this.checkStats.push({
          icon: 'fas fa-file-lines',
          value: stats.studies,
          description: 'Registros de&nbsp;Estudo'
        });

        this.checkStats.push({
          icon: 'fas fa-stopwatch',
          value: stats.durationStudiesWeek,
          unit: 'h',
          description: 'Estudadas Por&nbsp;Semana'
        });
      },
      error => {
        //
      }
    );
  }

  //Realizar Teste AB
  async TestAB() {
    //Criar ou Obter Id Único de Acesso à Plataforma
    let savedUniqueId = '';
    if (localStorage.getItem('testAB')) savedUniqueId = localStorage.getItem('testAB') || '';
    else savedUniqueId = Date.now().toString(36) + Math.random().toString(16).slice(2);
    localStorage.setItem('testAB', savedUniqueId);

    //Usuário Único
    const user: StatsigUser = { userID: savedUniqueId };

    //Desenvolvimento
    const environment = (window.location.hostname == 'localhost' || window.location.hostname.includes('vercel.app')) ? 'development' : 'production';
    const options: StatsigOptions = { environment: { tier: environment } };

    //Instanciar e Obter Experimento
    const statsigClient = new StatsigClient('client-MOCBGC62OIZEQBobw69FCGoxLrKewbBRE9YKOeRNEpx', user, options);
    await statsigClient.initializeAsync();
    const experiment = statsigClient.getExperiment('new_price');
    console.log(experiment);

    //Alterar Valores
    if (experiment?.value?.priceId) {
      this.subscriptions[0].price = (experiment.get('price') as number);
      this.subscriptions[0].cashPrice = (experiment.get('cashPrice') as number);
      this.subscriptions[0].link = (experiment.get('link') as string);
      this.subscriptions[0].activeCampaignFormId = (experiment.get('activeCampaignFormId') as number);
      this.subscriptions[0].activeCampaignFormOr = (experiment.get('activeCampaignFormOr') as string);
    }
  }

}
